import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
// import vueInstance from "@/index";
// import loginCallback from "./loginCallback";
// import logoutCallback from "./logoutCallback";


var storage = window.localStorage;
export default function(){
    // let token = storage.getItem("token");

    // if(!token && this.$route.path !== "/" && this.$route.path !== "/login" && this.$route.path !== "/register" && this.$route.path !== "/retriever"){
    //     this.$message.info("登录信息失效，请重新登录");
    //     this.$router.replace("/login");
    // }else if(!token){
    //     return;
    // }else if(this.$route.path === "/login" || this.$route.path !== "/register" || this.$route.path === "/retriever"){
    //     storage.removeItem("token");
    //     this.$store.userInfo = {};
    // };

    // server.getUserInfo({token}).then(data=>{
    //     if(data.reCode === SUCCESS_CODE){
    //         var result = getInterfaceData(data);
    //         this.$store.userInfo = result;
    //     }else{
    //         storage.removeItem("token");
    //         this.$store.userInfo = {};
    //         this.$message.info("登录信息失效，请重新登录");
    //         this.$router.replace("/login");
    //     }
    // })
};